import React, {useState} from 'react';
import {Input} from "../../shadCn/components/ui/input";
import SliderShowButton from "../../components/slide/SliderShowButton";
import DetailBtn from "../../../src/components/slide/sub/button/DetailBtn";
import CommonPagination from "../../../src/components/table/movable/CommonPagination";
import MaintenanceInfoSlide from "../../components/slide/sub/maintenance/MaintenanceInfoSlide";


function MaintenanceListThumbType({data, type, pageInfo, dataHook}) {
    const [searchTxt, setSearchTxt] =useState('');

    const {handleSearch, handlePageSizeChange,searchConditions, saveConditions, refresh, handleSortChange, handlePageChange} = dataHook;

    const inputListener=(e)=>{
        setSearchTxt(e.target.value);
    }

    //통합검색입력후 enter시 바로 검색할 수 있도록
    const handleOnKeyPress = e => {
        if (e.key === 'Enter') {

        }
    };


    const deleteAsset=()=>{
        alert("delete method should be implemented")
    }

    return (
        <div className="flex w-[100%]">
            <div className="list-container">
                <div className="list-container-top-search">
                    <Input value={searchTxt} onChange={inputListener} onKeyPress={handleOnKeyPress}  />
                </div>
                <div className="asset-thumbnail-container">
                    {data.map(each =>(
                        <SliderShowButton
                            data={each}
                            expose={70}
                            buttons={[<DetailBtn uri={`/maintenance/${type}/${each.id}`} />] }>

                            <MaintenanceInfoSlide data={each} type={type}/>

                        </SliderShowButton>
                    ))}
                </div>
                {data && data.length > 0 &&
                    <CommonPagination  page={pageInfo} onPageChange={handlePageChange}/>
                }
            </div>
        </div>
    );
}

export default MaintenanceListThumbType;